export const queryParams = {
  ORG_ID_QUERY: 'progress'
};

export const extractQuery = (query, url, customRegex) => {
  const regex = new RegExp(`/${query}/(.*?)/`);
  return url.match(customRegex || regex);
};
